@use "foundation/_responsive.scss";

.applet-card-body {
  .restore-button {
    width: 8.4em;
    margin: 0 1.2em 0 1.2em; // 24px

    button {
      color: white;
      background-color: rgba(0, 0, 0, 0.3);

      &.disabled {
        cursor: not-allowed;

        &:active {
          opacity: initial;
        }
      }
    }
  }

  span.with-image {
    max-height: 6.7em;
  }

  * {
    color: white;
  }
}
